import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class GlobalConstants {
    client: any;
    data: any;
    constructor(@Inject(DOCUMENT) private document: any) {
        let subDomain = this.document.location.hostname.split("www.").join("").split(".", 1);
        subDomain = subDomain.join("").split("sandbox-").join("").split(".", 1);
        this.client = "au-bank";

        if (this.document.location.hostname.includes("poshvine")) {
            this.client = subDomain[0];
            if (this.client.includes("-development")) {
                this.client = this.client.split("-development").join("");
            }
        }


        // AU bank data

        this.data = {
            "logo": {
                "url": "https://images.poshvine.com/logos/au-site-logo.png",
                "footerurl": "https://images.poshvine.com/logos/AU-bank-Scheduled-commercial-bank-logo-white.png",
                "desktop_url": "https://images.poshvine.com/logos/au-site-logo.png",
                "modal_url": "https://images.poshvine.com/logos/au-modal-logo.png",
                "favicon": "./assets/favicon/aufinance.ico",
                "head_logo_height": "43",
                "coupon_modal_logo": "https://images.poshvine.com/logos/au-site-logo.png"
            },
            "assets": {
                "img": {},
                "manifest": "au-bank.webmanifest"
            },
            "links": {
                "projectLink": "https://offers.aubank.in/"
            },
            "colors": {
                "header_bg_color": "#672474",
                "coupon_modal_bg_color": "#672474",
                "offer_title_color": '#672474',
                "main_text_color": '#262626',
                "medium_text_color": '#5C5C5C',
                "light_text_color": '#9D9D9D',
                "main_bg_color": '#ED6C37',
                "active_card_bg_color": '#F4F4F4',
                "seconday_bg_color": '#FDFCFA',
                "mainBtn_color": '#ED6C37',
                "inactive_btn_color": '#D8D8D8',
                "btn_positive_action_color": '#06B08A',
                "active_text_color": '#672474',
            },
            "legal_name": "AU Small Finance Bank",
            "font_family": {
                "link": "https://images.poshvine.com/fonts/gotham-round/Gotham-Rounded.css",
                "name": "Gotham-Rounded"
            },
            "x_header": {
              "prod": {
                "client_id": "3b1a1d77-0d4a-4edf-925d-230d45eaa37d",
                "project_id_credit": "2fc98a98-b3d2-4d54-8564-a17620c33c5c",
                "project_id_debit": "7ebeeb19-12fc-4f10-87a2-ac64e83d533e",
              },
              "sandbox": {
                "client_id": "c762195d-b49b-451e-b050-0aca4c36f770",
                "project_id_credit": "e3e60031-689c-499e-b627-da67db42c785",
                "project_id_debit": "6ec49a81-f06e-4d9f-9350-9e9b6e8d3685",
              },
              "default_card_type": "debit",
            },
            "search_type": 2,
            "desktop_category_count": 8,
            "card_num_type": "first4_last4",
            "card_type": "Debit",
            "tabs_type": "category",
            "tabs_type_mobile": "category",
            "has_exclusive": false,
            "banner_type": "slider",
            "login_button_needed": true,
            "loginAt": "otp",
            "login_theme": 1,
            "login_steps": ['mobile','otp','card'],
            "auto_expiry": {
                "time": "15",
                "enabled": true
            },
            "template": 1,
            "header_type": "au-bank",
            "show_saving_for_bundle_codes": {},
            "download_app_link": {
                'header': false,
                'footer': false,
                'android_link': null,
                'apple_link': null
            },
            "login_modal_type": "desktop-prev-header",
            "supported_devices": ['web', 'mobile'],
            "benefits": ['offers'],
            "banner_style": 1,
            "carouselInterval": -1,
            "api_version": 'v2',
            "credits_type": 'bundle',
            "token_attr": 'data',
            "personalized_config": {
                "coupon_terms_link": false,
                "switch_card": true,
                "autocard_check": true,
                "view_savings": true,
                "external_otp": false,
                "redemption_page_needed": true,
                "redemption_terms_btn": true,
                "saving_page": false,
                "resend_allowed": true,
                "add_new_card": false,
                "footer_logo": false,
                "force_auth": false,
                "token_auth": false,
                "desktop_search": true,
                "mobile_search": true,
                "auth": true,
                "coupon_modal": true,
                "coupon_show": true,
                "amount_show": false,
                "modal_redeem_button": true,
                "mobile_home_back_button": true,
                "show_card_used": true,
                "show_bundle_used": false,
                "allow_user_create": true,
                "otp_indication_msg": true,
                "enter_otp_line_2": true,
                "smart_country_dropdown": true,
                "dedicated_banner": true,
                "mobile_banner": true,
                "authenticate_before_claim": true,
                "disclaimer_popup": true,
                "cancelable_auth": true,
                "display_bundle_category_title": true,
                "mobile_login": true,
                "is_concierge": false,
                "has_card": true,
                "home_subcategory_dropdown": true,
                "home_subcategory_bar": true,
                "has_near_by": true,
                "has_international": true,
                "mobile_profile_dropdown": true,
                "category_page": true,
                "authenticate_bin": true,
                "datalayer": true,
                "has_add_card_text": true,
                "custom_gtm_tags": true,
                "show_terms_before_redeem": false,
                "details_desktop_tabs": true,
                "show_special_category": true,
                "send_project_id": false,
                "show_card_applicability": true,
                "card_applicability_fetch": 'api',
                "show_card_select_on_auth": true,
                "special_bundle": true,
                "external_login_banner": false,
                "has_international_offers": true,
                "send_as_gift": false,
                "applicableTag": true,
                "has_maps": false
            },
            "titles": {
                "homepage_pagetitle": "Card Offers, Discounts and Deals - AU Small Finance Bank",
                "homepage_description": "Avail exciting card offers, deals and discounts on shopping, travel, health, wellness, etc. Check out all the various benefits offered by AU Bank Card. Click to know more.",
                "homepage_keywords": "au bank offers, card offers, card discounts, card deals, card privileges, special offers, travel offers, entertainment offers, business offers, shopping offers, dining offers, health and wellness offers, offers near me",
                "header_title": "",
                "modal_mobile_label": "Enter your mobile number registered with AU Bank",
                "modal_email_label": "Enter your email address registered with AU Bank",
                "card_name": "AU Small Finance Bank Debit Card",
                "platform_title": "AU Small Finance Bank",
                "concierge_name": "AU Small Finance Bank",
                "login_modal_control": "Opt in to receive offers & benefits"
            },
            "footer_additional_content": "<p>Disclaimer: AU Small Finance Bank Offers Platform is a platform for communication of personalized offers extended by Merchants to AU Small Finance Bank's Customers. AU Small Finance Bank is only communicating the offers extended by Merchants to its Customers and not Selling/Rendering any of these Products/Services. AU Small Finance Bank is neither guaranteeing nor making any representation. AU Small Finance Bank is not responsible for Sale/Quality/Features of the Products/Services under the offers</p><p>Site is best viewed in Chrome V23+, Firefox V15+, Safari 6+ and IE11+ at 1024 x 768 pixels resolution, or above.</p>",
            "content": {
                "bin_error": {
                    "first4_last4": "Dear Customer, the combination of your mobile number and the first 4 and last 4 digits of your Debit Card number did not get validated. Please try again.",
                    "first6": "Dear customer, please re-check the first 6 digits of your card number you have entered"
                },
                "add_card_text": "We assure you that there will no transaction on your AU Bank Debit Card by sharing this information. This is only for verification of your AU Bank Account.",
                "autocard_check_otp_error": "Dear customer, currently we are unable to verify your account details. Please retry after sometime!",
                "autocard_check_card_error": "Please login using mobile number registered or linked with your AU Bank  Account",
                "autocard_check_card_go_to_link": "https://www.aubank.in/personal-banking/savings-account/savings-account-value?utm_source=poshvine&utm_medium=banner&utm_campaign=login_error_message"
            },
            "email": {
                display: 'customercare@aubank.in', val: 'customercare@aubank.in'
            },
            "phone": {
                display: '1800-1200-1200', val: '180012001200'
            },
            "rtm_enabled" : false
        };
    }
}
